import React, { FC, useState } from "react";

import {
  Checkbox,
  FormControl,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Theme,
} from "@mui/material";

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import "./style.css";
import theme from "src/theme/light";
import { InputSelectProperties } from "../InputSelect";

export interface SelectItem {
  text: string;
  value: string;
}

export interface InputSelectMultipleProperties extends InputSelectProperties {
  label: string;
  list: SelectItem[];
  value: string[];
  onChange(value: any): void;
}

export interface SelectMultipleState {
  list: string[];
  value: string[];
  itemField: string;
  valueField: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    formControl: {
      // margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    selectMuilt: {
      paddingBottom: "5px",
      paddingTop: "5px",
    },
    menuHeader: {
      backgroundColor: theme.palette.background.default,
    },
    chip: {
      margin: "0px 2px",
    },
    selectAdornment: {
      marginRight: theme.spacing(4),
    },
  })
);

const InputSelectMultiple: FC<InputSelectMultipleProperties> = (
  props: InputSelectMultipleProperties
) => {
  const classes = useStyles();

  const [values, setValues] = useState<string[]>(props.value);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const selecteds: string[] = event.target.value as string[];
    setValues(selecteds);
    if (props.onChange) {
      props.onChange(selecteds.join(","));
    }
  };

  return (
    <FormControl
      fullWidth={true}
      variant="outlined"
      size={"small"}
      className={classes.formControl}
      margin={"normal"}
    >
      <InputLabel
        id="select-regioes-label"
        style={{ backgroundColor: "#fff", padding: "0px 5px 0px 0px" }}
        hidden={props.list.length > 0}
      >
        {props.label}
      </InputLabel>
      <Select
        margin="dense"
        className={classes.selectMuilt}
        style={{
          textAlign: "left",
          padding: "0px",
          margin: "0px 0px -3px 0px",
        }}
        labelId="select-regioes-label"
        id="regiao-mutiple-checkbox"
        multiple
        value={values}
        onChange={handleChange}
        endAdornment={
          props.sufix ? (
            <InputAdornment className={classes.selectAdornment} position="end">
              {props.sufix}
            </InputAdornment>
          ) : null
        }
        renderValue={(selected) => {
          const selecteds: SelectItem[] = props.list.filter((item) =>
            (selected as string[]).includes(item.value)
          );
          return (
            <div className={classes.chip}>
              {selecteds.map((item, idx) => (
                <span key={item.value}>
                  {item.text}
                  {idx < selecteds.length - 1 ? ", " : ""}
                </span>
              ))}
            </div>
          );
        }}
        MenuProps={MenuProps}
      >
        {props.list.map((item: SelectItem) => (
          <MenuItem key={item.value} value={item.value}>
            <Checkbox checked={values.includes(item.value)} />
            <ListItemText primary={item.text} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export { InputSelectMultiple };
